import { render, staticRenderFns } from "./AnimationToggle.vue?vue&type=template&id=d4977e88"
import script from "./AnimationToggle.vue?vue&type=script&lang=js"
export * from "./AnimationToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports